if (!customElements.get('card-color-selectors')) {
  class CardColorSelectors extends HTMLElement {
    constructor() {
      super();
      this.colorButtons = this.querySelectorAll('button');
      this.card = this.closest('.product-card-wrapper');
      this.cardImage = this.card ? this.card.querySelector('.media > img') : null;
      this.cardLink = this.card ? this.card.querySelector('.card__heading a') : null;
      this.selectedColorWrapper = this.querySelector('[data-selected-color]');
      this.url = this.dataset.url;

      this.colorButtons.forEach((colorButton) => {
        colorButton.addEventListener('click', (e) => this.handleClick(e));
      });
    }

    handleClick(e) {
      this.clearSelection();
      this.currentColor = e.target.dataset.colorHandle;
      this.currentColorName = e.target.dataset.colorName;
      e.target.setAttribute('aria-selected', 'true');

      this.colorProduct = JSON.parse(
        e.target.querySelector('script[type="application/json"][data-color-product]')?.textContent || null
      );
      this.variantImage = JSON.parse(e.target.querySelector('script[type="application/json"]')?.textContent || null);

      this.changeImage();
      this.updateUrl();
      this.updateCardLink();
      this.updateCurrentColor();
    }

    updateUrl() {
      if (!this.currentColor || this.dataset.updateUrl !== 'true') return;
      window.history.replaceState({}, '', `${this.url}-${this.currentColor}`);
    }

    updateCardLink() {
      if (!this.card) return;
      const variantId = this.getVariantIdFromImage();
      if (!variantId) return;
      const newUrl = `${this.url}${this.currentColor ? `-${this.currentColor}` : ``}${
        variantId ? `?variant=${variantId}` : ``
      }`;
      this.cardLink.setAttribute('href', newUrl);
    }

    updateCurrentColor() {
      if (!this.selectedColorWrapper) return;
      this.selectedColorWrapper.innerHTML = this.currentColorName;
    }

    changeImage() {
      if (!this.cardImage || !this.variantImage) return;
      const original = this.cardImage.src.split('?')[0].replace(`https:`, ``).replace(`http:`, ``);
      const replacement = this.variantImage.preview_image.src.split('?')[0].replace(`https:`, ``).replace(`http:`, ``);
      const newSrcSet = this.cardImage.srcset.replaceAll(original, replacement);
      this.cardImage.srcset = newSrcSet;
      this.cardImage.src = replacement;
    }

    clearSelection() {
      this.colorButtons.forEach((btn) => btn.removeAttribute('aria-selected'));
    }

    getVariantIdFromImage() {
      let targetVariant = null;

      if (this.colorProduct && this.variantImage) {
        targetVariant = this.colorProduct.find((variant) => {
          const variantMediaId = variant.featured_media?.id;
          const selectedMediaId = this.variantImage?.id;
          return variantMediaId && selectedMediaId && variantMediaId === selectedMediaId;
        });
      }

      return targetVariant ? targetVariant.id : null;
    }

  }
  customElements.define('card-color-selectors', CardColorSelectors);

  if (!customElements.get('product-color-selectors')) {
    class ProductColorSelectors extends CardColorSelectors {
      constructor() {
        super();
        this.productInfo = this.closest('[id^=ProductInfo-');
        this.variantRadios = this.closest('[id^=ProductInfo-').querySelector('variant-radios') || null;
        this.productType = this.dataset.updateAs || 'single';

        this.abortControllerRef = {};
      }

      handleClick(e) {
        super.handleClick(e);
        this.selectedURL = `${this.url}-${e.currentTarget.dataset.colorHandle}`;
        this.currentColor = e.currentTarget.dataset.colorHandle;
        if (this.productType === 'single') {
          this.renderProductVariantRadios();
        } else {
          this.renderBundleVariantRadios();
        }
      }

      renderProductVariantRadios() {
        if (!this.selectedURL) return;
        if (this.abortControllerRef.current) this.abortControllerRef.current.abort('Abort current request, the User have chosen another variant');

        this.abortControllerRef.current = new AbortController();
        const signal = this.abortControllerRef.current.signal;

        this.enableLoadingState();

        fetch(`${this.selectedURL}?section_id=${this.dataset.section}`, { signal })
          .then((response) => response.text())
          .then((responseText) => {
            const radioId = `variant-radios-${this.dataset.section}`;
            const priceId = `price-${this.dataset.section}`;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const radioDestination = document.getElementById(radioId);
            const radioSource = html.getElementById(radioId);
            const priceDestination = document.getElementById(priceId);
            const priceSource = html.getElementById(priceId);

            this.updatePreorderProperty(html, this.closest('section[id*="MainProduct"]'));
            this.updateMedia(html, this.closest('section[id*="MainProduct"]'));
            this.updateProductMediaModal(html, this.closest('section[id*="MainProduct"]'))
            this.updateSwatchesAndVariantData({ radioSource, priceSource, radioDestination, priceDestination });
          })
          .catch((e) => console.log(e))
          .finally(() => this.disableLoadingState());
      }

      renderBundleVariantRadios() {
        if (!this.selectedURL) return;
        if (this.abortControllerRef.current) this.abortControllerRef.current.abort('Abort current request, the User have chosen another variant');

        this.abortControllerRef.current = new AbortController();
        const signal = this.abortControllerRef.current.signal;

        this.enableLoadingState();

        fetch(this.selectedURL, { signal })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const productInfoWrapper = html.querySelector('.product__info-wrapper')
            const sectionID = productInfoWrapper.id.slice(productInfoWrapper.id.indexOf('template'), productInfoWrapper.id.length);
            const closestMainSection = this.closest('section[id*="MainProduct"]');
            const closestMainSectionID = closestMainSection.id.slice(
                closestMainSection.id.indexOf('template'),
                closestMainSection.id.length);

            const renderedRadioId = `variant-radios-${sectionID}`;
            const renderedPriceId = `price-${sectionID}`;
            const localRadioId = `variant-radios-${closestMainSectionID}`;
            const localPriceId = `price-${closestMainSectionID}`;

            const radioSource = html.querySelector(`#${renderedRadioId}`);
            const priceSource = html.querySelector(`#${renderedPriceId}`);

            const radioDestination = closestMainSection.querySelector(`#${localRadioId}`);
            const priceDestination = closestMainSection.querySelector(`#${localPriceId}`);

            this.updatePreorderProperty(html, closestMainSection);
            this.updateBundleMedia(html, closestMainSection);
            this.updateSwatchesAndVariantData({ radioSource, priceSource, radioDestination, priceDestination, customID: closestMainSectionID, setFormIDToInputs: true });
          })
          .catch((e) => console.log(e))
          .finally(() => this.disableLoadingState());
      }

      updateSwatchesAndVariantData({ radioSource, priceSource, radioDestination, priceDestination, customID = null, setFormIDToInputs = true } = {}) {
        const selected = [];

        if (radioDestination) {
          radioDestination.querySelectorAll('input:checked').forEach((input) => {
            selected.push(`${input.value}`);
          });
        }

        if (radioSource && radioDestination) radioDestination.innerHTML = radioSource.innerHTML;
        if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;

        if (radioSource && radioDestination) {
          radioDestination.dataset.url = radioSource.dataset.url;
          selected.forEach((selectedInput) => {
            if (!radioDestination.querySelector(`[value="${selectedInput}"]`)) return;
            radioDestination.querySelector(`[value="${selectedInput}"]`).checked = true;
          });
          this.variantRadios.onVariantChange();
        }

        if (!customID) return;
        const formID = radioDestination.closest('section')?.querySelector('product-form>form')?.getAttribute('id');

        radioDestination.querySelectorAll('label').forEach(label => {
          const id = `${label.getAttribute('for')}${customID}`;
          label.setAttribute('for', id);

          if (label.previousElementSibling.nodeName !== 'INPUT') return;
          label.previousElementSibling.setAttribute('id', id);

          if (!formID || !setFormIDToInputs) return;
          label.previousElementSibling.setAttribute('form', formID);
        })
      }

      updatePreorderProperty(response, target) {
        const preorderInput = target.querySelector('#preorder-property');

        if (!preorderInput || !response.querySelector('#preorder-property')) return;

        preorderInput.outerHTML = response.querySelector('#preorder-property').outerHTML;
      }

      updateMedia(response, target) {
        const mediaGallery = target.querySelector('media-gallery');

        if (!mediaGallery || !response.querySelector('media-gallery')) return;

        mediaGallery.outerHTML = response.querySelector('media-gallery').outerHTML;
      }

      updateBundleMedia(response, target) {
        const mediaGallery = target.querySelector('media-gallery');
        const sectionId = this.dataset.section;

        if (!mediaGallery || !response.querySelector('media-gallery')) return;

        mediaGallery.querySelector('.product-gallery-viewer').innerHTML = response.querySelector('media-gallery .product-gallery-viewer').innerHTML;

        // set new IDs because response contains different content (from regular PDP)
        mediaGallery.querySelectorAll('[data-media-id]').forEach(item => {
          const dataMediaId = item.getAttribute('data-media-id');
          const splittedIdArray = dataMediaId.split('-');
          const mediaId = splittedIdArray[splittedIdArray.length - 1];
          item.setAttribute('data-media-id', `${sectionId}-${mediaId}`)
        })
      }

      updateProductMediaModal(response, target) {
        const modalId = target.querySelector('.product__modal-opener').getAttribute('data-modal');

        if (!modalId) return;

        const mediaModal = document.querySelector(`${modalId}`);

        if (!mediaModal || !response.querySelector(`${modalId}`)) return;

        mediaModal.outerHTML = response.querySelector(`${modalId}`).outerHTML;
      }

      enableLoadingState() {
        this.classList.add('loading');
      }

      disableLoadingState() {
        this.classList.remove('loading');
      }
    }
    customElements.define('product-color-selectors', ProductColorSelectors);
  }
}
